import { render, staticRenderFns } from "./Die_FinishingOptions.vue?vue&type=template&id=2685d5ca&scoped=true"
import script from "./Die_FinishingOptions.vue?vue&type=script&lang=js"
export * from "./Die_FinishingOptions.vue?vue&type=script&lang=js"
import style0 from "./Die_FinishingOptions.vue?vue&type=style&index=0&id=2685d5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685d5ca",
  null
  
)

export default component.exports